function renderImage(imageId, type, extension, merchantIdForLogin) {
  // type : the type of the image you need.... e.g original,blurred,large, etc...
  const merchantId = localStorage.getItem("merchantId") || merchantIdForLogin;
  const cdnUrl = process.env.REACT_APP_merchantimagecdn;
  if (!extension) {
    extension = ".jpeg";
  }
  if (imageId) {
    return `${cdnUrl}/${merchantId}/${imageId}/${type}${extension}`;
  } else {
    return "";
  }
}

export default renderImage;
